import React from 'react';

export type MultiplePointsIndicatorProps = {
  amount: number;
};

export default function MultiplePointsIndicator({
  amount,
}: MultiplePointsIndicatorProps): JSX.Element {
  return (
    <span className='talent-tree-node-multiple-points' aria-hidden>
      {amount}
    </span>
  );
}
